'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define(['app'], function (app) {
  var CardScroller = function () {
    function CardScroller() {
      _classCallCheck(this, CardScroller);

      this.init = this.init.bind(this);
      this.getScrollTo = this.getScrollTo.bind(this);
      this.scrollTo = this.scrollTo.bind(this);
      this.isElementInView = this.isElementInView.bind(this);
      this.highlightNavBullets = this.highlightNavBullets.bind(this);
      this.previous = this.previous.bind(this);
      this.next = this.next.bind(this);
    }

    _createClass(CardScroller, [{
      key: 'init',
      value: function init(element) {
        var _this = this;

        this.element = element;
        var classNamePrefix = element.getAttribute('data-card-scroller-target-class');

        var classNames = {
          jsLoaded: classNamePrefix + '-jsLoaded',
          scrollContainer: classNamePrefix + '_scrollContainer',
          cards: classNamePrefix + '_cards',
          card: classNamePrefix + '_card',
          navBullet: classNamePrefix + '_navBullet',
          navBulletActive: classNamePrefix + '_navBullet-active',
          previousButton: classNamePrefix + '_previousButton',
          nextButton: classNamePrefix + '_nextButton',
          navBullets: classNamePrefix + '_navBullets'
        };

        this.classNames = {
          card: classNamePrefix + '_card',
          navBullet: classNames.navBullet,
          navBulletActive: classNames.navBulletActive,
          navHidden: classNamePrefix + '_navHidden'
        };

        this.scrollContainer = element.querySelector('.' + classNames.scrollContainer);
        this.bulletElements = Array.from(element.getElementsByClassName(classNames.navBullet));
        this.bulletElements.forEach(function (bulletElement, index) {
          bulletElement.addEventListener('click', _this.getScrollTo(index));
        });

        this.prevButton = element.querySelector('.' + classNames.previousButton);
        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.previous);
        }

        this.nextButton = element.querySelector('.' + classNames.nextButton);
        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.next);
        }

        this.navBullets = element.querySelector('.' + classNames.navBullets);

        this.scrollContainer.addEventListener('scroll', this.highlightNavBullets);
        window.addEventListener('resize', this.highlightNavBullets);
        this.cards = element.querySelector('.' + classNames.cards);
        this.cardElements = Array.from(this.element.querySelectorAll('.' + this.classNames.card));
        app.element.addClass(classNames.jsLoaded, this.element);
        this.highlightNavBullets();
      }
    }, {
      key: 'getScrollTo',
      value: function getScrollTo(scrollIndex) {
        var _this2 = this;

        return function () {
          _this2.scrollTo(scrollIndex);
        };
      }
    }, {
      key: 'previous',
      value: function previous() {
        if (this.scrollContainer.scrollLeft === 0) {
          this.scrollTo(this.cardElements.length - 1);
        } else {
          var cardWidth = this.cardElements[0].offsetWidth;
          var numOfCardsInView = Math.max(Math.floor(this.cards.offsetWidth / cardWidth), 1);
          var activeBulletIndex = void 0;
          for (var i = 0; i < this.bulletElements.length; i++) {
            if (this.bulletElements[i].classList.contains(this.classNames.navBulletActive)) {
              activeBulletIndex = i;
              break;
            }
          }
          this.scrollTo(activeBulletIndex - numOfCardsInView);
        }
      }
    }, {
      key: 'next',
      value: function next() {
        var offsetWidth = void 0;
        var scrollWidth = void 0;
        if (document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl') {
          offsetWidth = -this.scrollContainer.offsetWidth;
          scrollWidth = -this.scrollContainer.scrollWidth;
        } else {
          offsetWidth = this.scrollContainer.offsetWidth;
          scrollWidth = this.scrollContainer.scrollWidth;
        }

        if (this.scrollContainer.scrollLeft + offsetWidth === scrollWidth) {
          this.scrollTo(0);
        } else {
          var cardWidth = this.cardElements[0].offsetWidth;
          var numOfCardsInView = Math.max(Math.floor(this.cards.offsetWidth / cardWidth), 1);
          var activeBulletIndex = void 0;
          for (var i = 0; i < this.bulletElements.length; i++) {
            if (this.bulletElements[i].classList.contains(this.classNames.navBulletActive)) {
              activeBulletIndex = i;
              break;
            }
          }
          this.scrollTo(activeBulletIndex + numOfCardsInView);
        }
      }
    }, {
      key: 'scrollTo',
      value: function scrollTo(scrollIndex) {
        var scrollContainer = this.scrollContainer;
        var cardWidth = this.cardElements[0].offsetWidth;
        var scrollAmount = void 0;
        if (document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl') {
          scrollAmount = cardWidth * scrollIndex + this.scrollContainer.scrollLeft;
        } else {
          scrollAmount = cardWidth * scrollIndex - this.scrollContainer.scrollLeft;
        }

        var leftDirection = scrollAmount > 0;
        scrollAmount = scrollAmount > 0 ? scrollAmount : -scrollAmount;
        var scrollIncrement = scrollAmount / 30;

        var id = void 0;
        var animateFrame = function animateFrame() {

          if (document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl') {
            if (scrollAmount <= 0) {
              clearInterval(id);
            } else if (leftDirection) {
              scrollAmount -= scrollIncrement;
              scrollContainer.scrollLeft -= scrollIncrement;
            } else {
              scrollAmount -= scrollIncrement;
              scrollContainer.scrollLeft += scrollIncrement;
            }
          } else {
            if (scrollAmount <= 0) {
              clearInterval(id);
            } else if (leftDirection) {
              scrollAmount -= scrollIncrement;
              scrollContainer.scrollLeft += scrollIncrement;
            } else {
              scrollAmount -= scrollIncrement;
              scrollContainer.scrollLeft -= scrollIncrement;
            }
          }
        };
        id = setInterval(animateFrame, 10);
      }
    }, {
      key: 'isElementInView',
      value: function isElementInView(cardElement, containerLeft, containerRight) {
        var cardLeft = cardElement.offsetLeft;
        var cardRight = cardLeft + cardElement.clientWidth;
        var halfCardWidth = cardElement.clientWidth * .5;
        return cardRight - halfCardWidth >= containerLeft && cardLeft <= containerRight - halfCardWidth;
      }
    }, {
      key: 'highlightNavBullets',
      value: function highlightNavBullets() {
        var _this3 = this;

        var containerLeft = this.scrollContainer.scrollLeft;
        var containerRight = containerLeft + this.scrollContainer.offsetWidth;
        var allElementsInView = true;

        this.cardElements.forEach(function (card, index) {
          var bulletElement = _this3.bulletElements[index];
          if (_this3.isElementInView(card, containerLeft, containerRight)) {
            app.element.addClass(_this3.classNames.navBulletActive, bulletElement);
          } else {
            app.element.removeClass(_this3.classNames.navBulletActive, bulletElement);
            allElementsInView = false;
          }
        });
        this.switchNavVisibility(allElementsInView);
      }
    }, {
      key: 'switchNavVisibility',
      value: function switchNavVisibility(allElementsInView) {
        if (!this.prevButton || !this.nextButton || !this.cardElements) {
          return;
        }
        var action = allElementsInView ? 'add' : 'remove';
        this.navBullets.classList[action](this.classNames.navHidden);
        this.prevButton.classList[action](this.classNames.navHidden);
        this.nextButton.classList[action](this.classNames.navHidden);
      }
    }]);

    return CardScroller;
  }();

  return CardScroller;
});
//# sourceMappingURL=card-scroller.js.map
